export const calculateTotalQuantityAndAmount= (itemList)=>{
    const quantity = itemList.reduce((total, item) => {
        return total + (Number(item?.qty) || 0);
    }, 0);
    const amount = itemList.reduce((total, item) => {
        return total + (parseFloat(item?.amt) || 0);
    }, 0);

    return {
        qty:quantity,
        amt:amount
    }
}

export const calculateGstAmount= (itemList)=>{
    const totalGst = itemList.reduce((total, item) => {
        const taxPercentage = parseFloat(item?.tax?.percentage) || 0;
        const itemAmount = parseFloat(item?.amt) || 0;

        if (taxPercentage > 0) {
            const gstAmount = (itemAmount * taxPercentage) / 100;
            return total + gstAmount;
        }
        return total;
    }, 0);
    return totalGst;
}

export const findMismatchedItems = (existingList, currentList) => {
    const existAmount = calculateTotalQuantityAndAmount(existingList);
    const currentAmount = calculateTotalQuantityAndAmount(currentList);
    const existGst = calculateGstAmount(existingList);
    const currentGst = calculateGstAmount(currentList);
    if(existAmount?.amt !== currentAmount?.amt){
        return true
    }
    else if(existGst !== currentGst){
        return true
    }
    else{
        return false
    }
}

export const calculateTdsAmount= (itemList)=>{
    return itemList.reduce((total, item) => {
        return total + (parseFloat(item?.tlAmt) || 0);
    }, 0);
}

export const calculateTdsBaseAmount= (itemList)=>{
    return itemList.reduce((total, item) => {
        return total + (parseFloat(item?.bsAmt) || 0);
    }, 0);
}
